import { jsx as d } from "react/jsx-runtime";
import { f as $ } from "../../../index-CtOScEKX.js";
import { TableBodyCell as g } from "./TableBodyCell.js";
import { useTable as x } from "../hooks/useTable.js";
import { propagateTestid as y } from "../../../helpers/utility/propagateTestid.js";
const j = ({
  additionalHeaders: a,
  hiddenHeader: f,
  rowProps: n = {},
  setControlViaRef: p,
  scope: u = "row",
  tableId: c,
  testId: o
}) => {
  const e = x(), m = e == null ? void 0 : e.api.getSortedRowModel().rows;
  return m != null && m.length ? m.map((r) => /* @__PURE__ */ d(
    "tr",
    {
      "data-testid": o == null ? void 0 : o.replace("tbody", "row"),
      id: `${c}--rows--${r.id}`,
      ref: (i) => {
        const l = `${c}--rows--${r.id}`;
        p == null || p(l)(i);
      },
      ...typeof n == "function" ? n(r) : n,
      children: r.getVisibleCells().map((i, l) => /* @__PURE__ */ d(
        g,
        {
          additionalHeaders: a,
          "data-testid": y(
            o == null ? void 0 : o.replace("tbody", "cell"),
            `row_${r.id}__col_${i.column.id}`
          ),
          cellApi: i,
          hiddenHeader: f,
          index: l,
          scope: u,
          tableId: c,
          children: $(i.column.columnDef.cell, i.getContext())
        },
        i.id
      ))
    },
    r.id
  )) : null;
};
export {
  j as TableRows
};
